export const SOURCES_URL = 'sources'
export const SOURCE_CHANNELS_URL = 'channels'
export const SOURCE_PROVIDERS_URL = 'data-providers'
export const SOURCES_API_URL = '/client/admin/sources'
export const SOURCE_CHANNEL_TYPES_URL = 'channel-types'
export const SOURCE_TYPES_URL = 'types'
